export default function SizeInput({ label, placeholder, options, value, onChange }) {
  const listId = 'size-options-list';

  return (
    <div>
      <label htmlFor="size-input" className="block text-sm font-medium text-slate-300 mb-2">
        {label}
      </label>
      <input
        id="size-input"
        type="text"
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-slate-700 bg-slate-800 px-4 py-3 text-white placeholder-slate-500 focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500"
      />
      <datalist id={listId}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} />
        ))}
      </datalist>
    </div>
  );
}
